import { Bound, Position } from '@/shared/ui/data/EditableGrid/types/core.type';

export function createPosition(rowIndex: number, colIndex: number): Position {
  return { rowIndex, colIndex };
}

export function isSamePosition(a: Position, b: Position): boolean {
  return a.rowIndex === b.rowIndex && a.colIndex === b.colIndex;
}

export function includesPosition(positions: ReadonlyArray<Position>, position: Position): boolean {
  return positions.some((pos) => isSamePosition(pos, position));
}

export function isInBounds(position: Position, bound: Bound): boolean {
  return (
    position.rowIndex >= 0 &&
    position.rowIndex < bound.rowCount &&
    position.colIndex >= 0 &&
    position.colIndex < bound.colCount
  );
}
